import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NGXLogger } from 'ngx-logger';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CreateClientService } from '../../../api/create-client.service';
import { CreateEnterprisePanelService } from '../../../services/create-enterprise-panel.service';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { GT2PageAbstract } from '../../../content/abstract/GT2PageAbstract';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Settings } from '../../../settings/settings';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { Gt2LocaleService } from '../../../../localization/gt2-locale.service';
import { locale as englishAddress } from '../../address/i18n/en-CA';
import { locale as frenchAddress } from '../../address/i18n/fr-CA';
import { locale as englishContact } from '../../contact/i18n/en-CA';
import { locale as frenchContact } from '../../contact/i18n/fr-CA';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EditorModule } from 'primeng/editor';
import { ViewHtmlButtonDirective } from '../../../directives/view-html-button.directive';
import { AddressAutocompleteComponent } from '../../address-autocomplete/address-autocomplete.component';
import { EmojiPickerButtonComponent } from '../../emoji-picker-button/emoji-picker-button.component';
@Component({
  selector: 'app-create-enterprise-with-details',
  templateUrl: './create-enterprise-with-details.component.html',
  styleUrls: ['./create-enterprise-with-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    EditorModule,
    ViewHtmlButtonDirective,
    EmojiPickerButtonComponent,
    MatAutocompleteModule,
    TranslateModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    AddressAutocompleteComponent,
  ],
})
export class CreateEnterpriseWithDetailsComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit
{
  form: UntypedFormGroup;
  enterprise: any;
  override loading: boolean = false;
  type?: string;
  uuid?: string;
  userSettings: any = {
    inputPlaceholderText: '',
    showRecentSearch: true,
  };
  noGeoLocation: boolean = false;
  addressPrefillDirty: boolean = false;
  addressUnknown: boolean = false;
  constructor(
    private panelService: CreateEnterprisePanelService,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    private createclientService: CreateClientService,
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    public router: Router,
    private toastr: ToastrService,
    private logger: NGXLogger,
    public gt2LocalService: Gt2LocaleService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);
    this.translationLoader.loadTranslations(englishAddress, frenchAddress);
    this.translationLoader.loadTranslations(englishContact, frenchContact);
    this.userSettings.inputPlaceholderText = this.translate.instant(
      'GENERIC.GOOGLE_ADDRESS_PLACEHOLDER',
    );

    this.form = this.formBuilder.group({
      name: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      professional_email: ['', [Validators.email]],
      telephone_office: [
        '',
        [Validators.minLength(2), Validators.maxLength(100)],
      ],
      telephone_office_ext: [
        '',
        [Validators.minLength(2), Validators.maxLength(20)],
      ],
      street_number: [
        '',
        [
          Validators.minLength(1),
          Validators.maxLength(25),
          Validators.required,
        ],
      ],
      street: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      apartment: '',
      line2: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
        ],
      ],
      city: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      province: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      country: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      postal_code: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
    });

    this.enterprise = {
      name: null,
      note: null,
      contact: {
        email_organisation: null,
        telephone_office: null,
        telephone_office_ext: null,
      },
      address: {
        street_number: null,
        street: null,
        apartment: null,
        line2: null,
        city: null,
        province: null,
        country: null,
        postal_code: null,
      },
    };
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  public handleAddressChange(address: any) {
    if (address.response === false) {
      this.noGeoLocation = true;
      return;
    } else {
      this.noGeoLocation = false;

      Promise.resolve(null).then(() => {
        this.enterprise.address.street_number = this.findAddressProperty(
          address,
          'street_number',
        );
        this.enterprise.address.street = this.findAddressProperty(
          address,
          'route',
        );
        this.enterprise.address.city = this.findAddressProperty(
          address,
          'locality',
        );
        this.enterprise.address.province = this.findAddressProperty(
          address,
          'administrative_area_level_1',
        );
        this.enterprise.address.country = this.findAddressProperty(
          address,
          'country',
        );
        this.enterprise.address.postal_code = this.findAddressProperty(
          address,
          'postal_code',
        );
        this.enterprise.address.lat = address.data.geometry.location.lat;
        this.enterprise.address.long = address.data.geometry.location.lng;
        this.enterprise.address.full_address = address.data.formatted_address;

        this.addressPrefillDirty = true;
        this.cdr.detectChanges();
      });
    }
  }

  public findAddressProperty(address: any, key: string): string {
    const item = address.data.address_components.find((data: any) => {
      return data.types.indexOf(key) !== -1;
    });

    if (item && item.long_name) {
      return item.long_name;
    }
    return '';
  }

  public onAddressUnknownChange() {
    // Handle address unknown checkbox change if needed
  }

  public onCreateEnterprise(): void {
    this.loading = true;
    this.createclientService.createEnterprise(this.enterprise).subscribe({
      next: (response: any) => {
        this.toastr.success(
          '',
          this.translate.instant('GENERIC.API_CALL_SUCCESS.CREATE_enterprise'),
        );
        this.panelService.emitResult(response.data);
        this.loading = false;
      },
      error: (error: any) => {
        this.logger.error(
          'CreateenterpriseComponent.onCreateenterprise() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.loading = false;
        this.handleAPIError(
          error,
          this.dialog,
          this.toastr,
          this.translate.instant('GENERIC.ERRORS.CREATE_enterprise'),
          this.router,
        );
      },
    });
  }

  public close(): void {
    this.panelService.emitResult(false);
  }
}
